import { Link } from '@tanstack/react-router';
import { createContext, useContext, type ReactNode } from 'react';

/**
 * Where an area lives, by its slug - given by the shell from the navigation. Handed down, not
 * imported: the navigation shows cards that link to areas, which would lead back to it.
 */
export const AreaBases = createContext<(slug: string) => '/firm' | '/settings'>(() => '/settings');

/**
 * The way to an area, wherever it lives - the firm's own data under „Kanzlei“, the rest in the
 * settings; `tab` opens one tab of it.
 */
export function AreaLink({
  area,
  tab,
  className,
  children,
}: {
  area: string;
  tab?: string | undefined;
  className: string;
  children: ReactNode;
}) {
  const baseOf = useContext(AreaBases);
  return (
    <Link
      to={`${baseOf(area)}/$area`}
      params={{ area }}
      search={tab ? { tab } : {}}
      className={className}
    >
      {children}
    </Link>
  );
}
